/* eslint-disable max-len */
import {
  IAvailableTimesResponse,
  IGetAvailableTimesParams,
} from "../available-times/available-times.interface";
import { getUnixTimestamp } from "../../utils";
import { useEffect, useState } from "react";

import { IOptionGeneric } from "../../shared/interface";
import { mapToAvailableTimesRequest } from "../available-times/available-times.mapper";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useLazyQuery } from "@apollo/client";
import { useUpdateLocationStore } from "../../hooks/redux-hooks/updateLocation-store/updateLocation-store";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";
import { AVAILABLE_DROPOFF_TIMES } from "./drop-off-appointment.query";
import { availableTimesMap, daysOfMonthMap } from "../available-times/available-times.service";

export const useAvailableDropoffTimes = () => {
  const { user } = useUserStore();
  const { reasonForVisit, selectedPets } = useAppointmentStore();
  const [daysOfMonthDropoffList, setDaysOfMonthDropoffList] = useState<IOptionGeneric[]>([]);
  const [dropoffTimesList, setDropoffTimesList] = useState<IOptionGeneric[]>([]);
  const { locationSelected } = useUpdateLocationStore();

  const [
    availableTimesForDropOff, { data, loading, error },
  ] = useLazyQuery<{ availableTimesForDropOffV2: IAvailableTimesResponse }>(AVAILABLE_DROPOFF_TIMES);
  const [currentDay, setCurrentDay] = useState<string>("");

  const getAvailableDropoffTimes = ({ reasons, date, isPreviewModal }: IGetAvailableTimesParams) => {
    availableTimesForDropOff({
      variables: {
        data: mapToAvailableTimesRequest(reasons || reasonForVisit, selectedPets,
          date, isPreviewModal?Number(locationSelected[0].idLocation):Number(user?.location?.idLocation)!),
      },
      fetchPolicy: "cache-and-network",
    });
  };

  useEffect(() => {
    if (data) {
      setDaysOfMonthDropoffList(daysOfMonthMap(data.availableTimesForDropOffV2.daysMonth));
      setDropoffTimesList(availableTimesMap(data.availableTimesForDropOffV2.availableTimes.times, data.availableTimesForDropOffV2.timeZone));

      const dayUTC = new Date(+data.availableTimesForDropOffV2.availableTimes.date * 1000).toUTCString().split(" ");
      const day = getUnixTimestamp(new Date(`${dayUTC[1]} ${dayUTC[2]} ${dayUTC[3]}`)).toString();

      setCurrentDay(day.toString());
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setDaysOfMonthDropoffList([]);
      setDropoffTimesList([]);
    }
  }, [error]);

  return {
    loading,
    getAvailableDropoffTimes,
    daysOfMonthDropoffList,
    dropoffTimesList,
    currentDay,
    findDropoffAvailability: data?.availableTimesForDropOffV2,
    dropoffAppointmentType: data?.availableTimesForDropOffV2?.appointmentCreateType,
  };
};
